import { render, staticRenderFns } from "./GblchnlWhiteList.vue?vue&type=template&id=6062b84a"
import script from "./GblchnlWhiteList.vue?vue&type=script&lang=js"
export * from "./GblchnlWhiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports